import request from 'client/utils/request'
import { PageLocaleEnum } from 'common/enums/PageLocaleEnum'

interface getUserPlansProps {
  locale: PageLocaleEnum
}

export const getUserPlans = ({ locale }: getUserPlansProps) => {
  return request.get(`/user-plans/${locale}`)
}
